












import SidebarMobileToggle from "@/components/SidebarMobileToggle.vue";
import { Layout } from "@/types/layout";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({ components: { SidebarMobileToggle } })
export default class LayoutSideBar extends Vue {
  beforeCreate() {
    this.$store.dispatch("setLayout", Layout.HAS_SIDEBAR);
  }

  @State("mobileMenuOpen") mobileMenuOpen!: boolean;

  // Close sidebar mobile menu on click (when an item in the sidebar has been clicked)
  closeMobileMenu() {
    if (this.mobileMenuOpen) this.$store.dispatch("toggleMobileMenu", false);
  }
}
